import { render, staticRenderFns } from "./LastMinuteLessons.vue?vue&type=template&id=51b6408c&scoped=true"
import script from "./LastMinuteLessons.vue?vue&type=script&lang=js"
export * from "./LastMinuteLessons.vue?vue&type=script&lang=js"
import style0 from "./LastMinuteLessons.vue?vue&type=style&index=0&id=51b6408c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b6408c",
  null
  
)

export default component.exports